export const createStaffMenuSlice = (set, get) => ({
  activeMenu: 'POS',

  // Actions
  setActiveMenu: (menu) => set({ activeMenu: menu })
});